var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-info" }, [
      _c("div", { staticClass: "form-row" }, [
        _c(
          "div",
          { staticClass: "form-value", staticStyle: { width: "300px" } },
          [
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.toSelectAssetStockInItem(
                      _vm.voucherId,
                      _vm.ioFlag,
                      _vm.goodsRecvVoucherItemList
                    )
                  }
                }
              },
              [_c("span", [_vm._v("选择条目")])]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "fr" }, [
          !_vm.autoInFiscal && !_vm.lowCostFlag
            ? _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v(" ")])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.autoInFiscal && !_vm.lowCostFlag
            ? _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.autoFiscalIn,
                          callback: function($$v) {
                            _vm.autoFiscalIn = $$v
                          },
                          expression: "autoFiscalIn"
                        }
                      },
                      [_vm._v("自动入账")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.autoFiscalIn
            ? _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v(" ")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.autoFiscalIn
            ? _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.changeAutoReceive },
                        model: {
                          value: _vm.autoReceive,
                          callback: function($$v) {
                            _vm.autoReceive = $$v
                          },
                          expression: "autoReceive"
                        }
                      },
                      [_vm._v("机构负责人自动领用")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showBizUnitWarehouse
            ? _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("入库仓库")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showBizUnitWarehouse
            ? _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel" },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "mb10 mr5",
                        attrs: { clearable: true },
                        model: {
                          value: _vm.warehouseId,
                          callback: function($$v) {
                            _vm.warehouseId = $$v
                          },
                          expression: "warehouseId"
                        }
                      },
                      _vm._l(_vm.warehouseList, function(item) {
                        return _c("el-option", {
                          attrs: { label: item.name, value: item.id }
                        })
                      })
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticClass: "thin",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.goodsRecvVoucherItemList, border: "" },
            on: { "selection-change": _vm.handleSelectionChange }
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "selection",
                width: "40",
                align: "center",
                fixed: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "title",
                label: "商品名称",
                width: "120",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "catName",
                label: "分类",
                width: "120",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "brandName",
                label: "品牌",
                width: "120",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "model",
                label: "型号",
                width: "120",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "fixedSpec",
                label: "规格",
                width: "120",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "wrntPeriod",
                label: "保质期(月)",
                width: "80",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "quantity",
                label: "收货数量",
                width: "80",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "useableQuantity",
                label: "可入库数量",
                width: "80",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "unit", label: "单位", width: "50", align: "left" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "unit",
                label: "管理方式",
                width: "150",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.srcAssetDefId == -1
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: {
                                    change: function($event) {
                                      _vm.assetTypeChange(rows.row)
                                    }
                                  },
                                  model: {
                                    value: rows.row.assetType,
                                    callback: function($$v) {
                                      _vm.$set(rows.row, "assetType", $$v)
                                    },
                                    expression: "rows.row.assetType"
                                  }
                                },
                                _vm._l(_vm.assetTypeList, function(item) {
                                  return _c(
                                    "el-radio",
                                    { attrs: { label: item.value } },
                                    [_vm._v(_vm._s(item.text))]
                                  )
                                })
                              )
                            ],
                            1
                          )
                        : _c("div", [
                            _vm._v(
                              _vm._s(_vm.assetTypeEnumMap[rows.row.assetType])
                            )
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "devcDefId", label: "关联定义", width: "250" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.assetDefId != -1
                        ? _c("div", { staticClass: "inline-block" }, [
                            _vm._v("已关联")
                          ])
                        : _c("div", { staticClass: "inline-block" }, [
                            _vm._v("未关联")
                          ]),
                      _vm._v(" "),
                      rows.row.srcAssetDefId == -1
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link fr inline-block",
                                on: {
                                  click: function($event) {
                                    _vm.delDef(rows.row)
                                  }
                                }
                              },
                              [_vm._v("清除")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link fr inline-block",
                                on: {
                                  click: function($event) {
                                    _vm.setDef(rows.row)
                                  }
                                }
                              },
                              [_vm._v("选择")]
                            ),
                            _vm._v(" "),
                            rows.row.assetDefId == -1 &&
                            (rows.row.assetType == 3 ||
                              (!_vm.needAudit && rows.row.assetType != 3))
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link fr inline-block",
                                    on: {
                                      click: function($event) {
                                        _vm.saveDef(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("生成定义")]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      rows.row.assetDefId != -1
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link fr inline-block",
                              on: {
                                click: function($event) {
                                  _vm.showDevcDef(rows.row.assetDefId)
                                }
                              }
                            },
                            [_vm._v("查看")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "specialFlag",
                label: "特种设备",
                width: "100",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: rows.row.specialFlag,
                            expression: "rows.row.specialFlag"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          disabled: rows.row.assetType != 0
                        },
                        domProps: {
                          checked: Array.isArray(rows.row.specialFlag)
                            ? _vm._i(rows.row.specialFlag, null) > -1
                            : rows.row.specialFlag
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = rows.row.specialFlag,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      rows.row,
                                      "specialFlag",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      rows.row,
                                      "specialFlag",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(rows.row, "specialFlag", $$c)
                              }
                            },
                            function($event) {
                              _vm.setSpecialDevice(rows.row)
                            }
                          ]
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "leasible",
                label: "是否可出租",
                width: "100",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: rows.row.leasible,
                            expression: "rows.row.leasible"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          disabled: rows.row.assetType != 0
                        },
                        domProps: {
                          checked: Array.isArray(rows.row.leasible)
                            ? _vm._i(rows.row.leasible, null) > -1
                            : rows.row.leasible
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = rows.row.leasible,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      rows.row,
                                      "leasible",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      rows.row,
                                      "leasible",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(rows.row, "leasible", $$c)
                              }
                            },
                            function($event) {
                              _vm.setLeasible(rows.row)
                            }
                          ]
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "useableQuantity",
                label: "入库数量",
                width: "100",
                align: "right"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("el-input", {
                        staticClass: "text-right",
                        attrs: {
                          type: "number",
                          disabled: rows.row.assetType != 2
                        },
                        model: {
                          value: rows.row.theQuantity,
                          callback: function($$v) {
                            _vm.$set(rows.row, "theQuantity", $$v)
                          },
                          expression: "rows.row.theQuantity"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "theUnit",
                label: "入库单位",
                width: "70",
                align: "left"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("el-autocomplete", {
                        attrs: {
                          disabled: _vm.assetType != 2,
                          "fetch-suggestions": function(queryString, callback) {
                            _vm.querySearch(
                              queryString,
                              callback,
                              rows.row.catId
                            )
                          }
                        },
                        model: {
                          value: rows.row.theUnit,
                          callback: function($$v) {
                            _vm.$set(rows.row, "theUnit", $$v)
                          },
                          expression: "rows.row.theUnit"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "batchNo",
                label: "批次号",
                width: "140",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "desc",
                label: "备注",
                width: "200",
                align: "left"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("el-input", {
                        staticClass: "textarea-value",
                        attrs: { type: "textarea" },
                        model: {
                          value: rows.row.desc,
                          callback: function($$v) {
                            _vm.$set(rows.row, "desc", $$v)
                          },
                          expression: "rows.row.desc"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "外部系统编号",
                width: "500",
                align: "left",
                "render-header": _vm.renderInnerNo
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("swb-file-upload", {
                        staticClass: "mt5 fl",
                        attrs: {
                          fileGroup: "retailerInnerNo.extract",
                          onBeforeUpload: _vm.onBeforeUploadInnerNo,
                          onProgress: _vm.onProgressInnerNo,
                          onDone: function(event) {
                            _vm.onUploadDoneInnerNo(event, rows.row.id)
                          },
                          multipleFile: false
                        }
                      }),
                      _vm._v(" "),
                      rows.row.innerNoList != null &&
                      rows.row.innerNoList.length > 0
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.viewInnerNo(rows.row.id)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "查看(" +
                                  _vm._s(rows.row.innerNoList.length) +
                                  ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      rows.row.innerNoList != null &&
                      rows.row.innerNoList.length > 0
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.clearInnerNo(rows.row.id)
                                }
                              }
                            },
                            [_vm._v("清除")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                width: "180",
                align: "left",
                fixed: "right"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _vm.ukNoMap[rows.row.shipVoucherItemId] != null
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.viewUkNo(rows.row.shipVoucherItemId)
                                }
                              }
                            },
                            [_vm._v("查看商品标识码")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.doDeleteStockInItem(rows.row.id)
                            }
                          }
                        },
                        [_vm._v("移除")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eeacb068", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeacb068","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/AssetStockInItemList.vue
// module id = 2651
// module chunks = 0